module.exports = __webpack_public_path__ + "img/Roboto-Medium.3b290a9b.svg";